// extracted by mini-css-extract-plugin
module.exports = {"content":"Custom_01_content__2TqZW"};